import { GeneralCatalogItem } from 'data-layer-cr/dist/models';
import { useEffect } from 'react';

import { cities as staticCities } from 'src/data/citiesCr.json';
import { states as staticStates } from 'src/data/statesCr.json';
import { townships as staticTownships } from 'src/data/townshipsCr.json';
import {
  findIdByCode,
  findNameByCode,
} from 'src/functions/mapCatatalogToDisplay';
import EmissionDataFields from 'src/models/helperTypes/EmissionDataFields';

type Props = {
  dataFields: EmissionDataFields;
  countryStates: GeneralCatalogItem[];
  cities: GeneralCatalogItem[];
  getCitiesAction: (value: string | number) => unknown;
  getTownshipsAction: (value: string | number) => unknown;
  setDataFieldsAction: (data: EmissionDataFields) => unknown;
};

export default function usePersistedAddressInformation({
  dataFields,
  countryStates,
  cities,
  getCitiesAction,
  getTownshipsAction,
  setDataFieldsAction,
}: Props): void {
  useEffect(() => {
    if (dataFields.addressState && countryStates.length > 0) {
      const stateId = findIdByCode(countryStates, dataFields.addressState);
      if (stateId) {
        getCitiesAction(stateId);
      }
    }
  }, [dataFields.addressState, countryStates, getCitiesAction]);

  useEffect(() => {
    if (dataFields.addressCity && cities.length > 0) {
      const cityId = findIdByCode(cities, dataFields.addressCity);
      if (cityId) {
        getTownshipsAction(cityId);
      }
    }
  }, [dataFields.addressCity, cities, getTownshipsAction]);

  useEffect(() => {
    if (dataFields.addressCity && dataFields.addressState) {
      const staticState = staticStates.find(
        (item) => item.code === dataFields.addressState,
      );
      const citiesForState = staticCities.filter(
        (item) => item.parentId === staticState?.id,
      );
      const correctCityName = findNameByCode(
        citiesForState,
        dataFields.addressCity,
      );
      const staticCity = citiesForState.find(
        (item) => item.code === dataFields.addressCity,
      );
      const townshipsForCity = staticTownships.filter(
        (item) => item.parentId === staticCity?.id,
      );
      const correctTownshipName = findNameByCode(
        townshipsForCity,
        dataFields.addressTownship,
      );
      const needsCityUpdate =
        correctCityName && correctCityName !== dataFields.addressCityName;
      const needsTownshipUpdate =
        correctTownshipName &&
        correctTownshipName !== dataFields.addressTownshipName;

      if (needsCityUpdate || needsTownshipUpdate) {
        setDataFieldsAction({
          ...dataFields,
          ...(needsCityUpdate ? { addressCityName: correctCityName } : {}),
          ...(needsTownshipUpdate
            ? { addressTownshipName: correctTownshipName }
            : {}),
        });
      }
    }
  }, [
    dataFields.addressCity,
    dataFields.addressState,
    dataFields.addressTownship,
    dataFields.addressCityName,
    dataFields.addressTownshipName,
    setDataFieldsAction,
  ]);
}
